import React, {useEffect, useState} from 'react'
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";


// components
import SectionsList from "./_list";
import SectionForm from "./_form";
import {GenericButton} from "../../../../components/buttons/customButtons";
import LinkedSections from "./LinkedSections";
import {showLoader} from "../../../../components/loader/loader";

// labels
import {ADD_STATE, REMOVE_STATE, setForm, setItem} from "../../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";

const Sections = (props) => {
    const path = `${props.path}/sections`;
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    const [showFormModal, setShowFormModal] = useState(false);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    const onCreateItem = () => {
        props.setItem(path, null);
        props.setForm(path)
        setShowFormModal(!showFormModal);
    }

    const onEditItem = (data) => {
        props.setItem(path, data);
        props.setForm(path, true, false, false)
        setShowFormModal(!showFormModal);
    }

    const handleShowFormModal = () => setShowFormModal(!showFormModal);



    return <>
        {loading && showLoader()}

        <Card className={'internal-card'}>
            <CardTitle className="internal-title-card">
                <i className="far fa-edit"/> Secciones
                <div className="top-right actions">
                    <GenericButton
                        style={'table'}
                        label={'Nueva Sección'}
                        toolTip={'Nueva Sección'}
                        icon={'fa-plus'}
                        permission={'add'}
                        onClick={onCreateItem}
                    />
                </div>
            </CardTitle>
            <CardBody className={'internal-body-card'}>
                <LinkedSections path={props.path} />
                <SectionsList
                    path={props.path}
                    toggleModal={handleShowFormModal}
                    onEdit={onEditItem}
                />
            </CardBody>
        </Card>

        {
            showFormModal && <SectionForm
                path={props.path}
                isOpen={showFormModal}
                toggle={handleShowFormModal}
            />
        }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem, setForm
})

export default connect(mapStateToProps, mapActionsToProps)(Sections);